export const searchFn = (array= [], searchText= '') => {
    return array.filter(el => el.name.toLowerCase().includes(searchText.toLowerCase()))
}